import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'call',
  pure: false,
})
export class CallPipe implements PipeTransform {
  transform<T>(func: () => T): T;
  transform<T, P>(func: (p: P) => T, funcParam: P): T;
  transform<T, P1, P2>(func: (p1: P1, p2: P2) => T, p1: P1, p2: P2): T;
  transform<T, P1, P2, P3>(func: (p1: P1, p2: P2, p3: P3) => T, p1: P1, p2: P2, p3: P3): T;
  transform<T, P1, P2, P3, P4>(
    func: (p1: P1, p2: P2, p3: P3, p4: P4) => T,
    p1: P1,
    p2: P2,
    p3: P3,
    p4: P4,
  ): T;
  transform<T, P1, P2, P3, P4, P5>(
    func: (p1: P1, p2: P2, p3: P3, p4: P4, p5: P5) => T,
    p1: P1,
    p2: P2,
    p3: P3,
    p4: P4,
    p5: P5,
  ): T;
  transform<T, P1, P2, P3, P4, P5>(
    func: (p1: P1, p2: P2, p3: P3, p4: P4, p5: P5, ...pn: unknown[]) => T,
    p1: P1,
    p2: P2,
    p3: P3,
    p4: P4,
    p5: P5,
    ...pn: unknown[]
  ): T;

  transform<T>(func: (...x: any[]) => T, ...funcParams: any[]): T {
    return func(...funcParams);
  }
}
